module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "module-name"
  }, [_vm._v("ASSINGMENT")]), _vm._v(" "), (_vm.getLoading) ? _c('vue-spinner') : _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "general-item-list min110"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-body"
  }, [_vm._v("Program Start Date: " + _vm._s(_vm._f("formatDateModalNoTimeZone")(_vm.programStartDate)))]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_vm._v("Program Status: " + _vm._s(_vm.programStatus))]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_vm._v("Case Manager: " + _vm._s(_vm.caseManager))]), _vm._v(" "), (_vm.secondaryCaseManager && _vm.secondaryCaseManager.trim() != '') ? _c('div', {
    staticClass: "item-body"
  }, [_vm._v("Secondary Case Manager: " + _vm._s(_vm.secondaryCaseManager))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-arrow-link pull-right"
  }, [_c('router-link', {
    staticClass: "text-warning",
    attrs: {
      "to": {
        name: 'Participant Assignment',
        params: {
          id: (_vm.$route.params.id != null) ? _vm.$route.params.id : '97'
        }
      },
      "tag": "a"
    }
  }, [_vm._v("\n        VIEW|EDIT "), _c('i', {
    staticClass: "icon-arrow-right black"
  })]), _vm._v(" "), ((_vm.getParticipant.assignment != null && _vm.getParticipant.assignment.length == 0) && _vm.getUser.access > 2) ? _c('router-link', {
    staticClass: "text-warning",
    attrs: {
      "to": {
        name: 'Participant Assignment',
        params: {
          id: (_vm.$route.params.id != null) ? _vm.$route.params.id : '97'
        }
      },
      "tag": "a"
    }
  }, [_vm._v("\n        NEW "), _c('em', {
    staticClass: "fa fa-angle-down"
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86b56364","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Assingment.vue
// module id = 1717
// module chunks = 1